module.exports = __webpack_public_path__ + "img/triangle-right.78c6becb.png";